<template>
  <div class="clinic-features">
    <v-container>
      <PatientsAppClinicFeature @click="handleConnectMedtochkaButtonClick" />

      <DocumentsClinicFeature class="clinic-features__next-section" />

      <TelemedClinicFeature
        class="clinic-features__next-section"
        @click="handleConnectTelemedButtonClick"
      />

      <LoyaltyClinicFeature class="clinic-features__next-section" />
    </v-container>

    <MedtochkaReviews class="clinic-features__next-section" />

    <div class="mt-8 mt-md-12 d-flex justify-center px-2">
      <LandingFeatureBtn
        text="Подключить МедТочку"
        width="360"
        @click="handleConnectMedtochkaButtonClick"
      />
    </div>

    <ConnectMedtochkaDialog
      ref="connectMedtochkaDialog"
      @click:send="handleClickSend"
      @error="handleError"
    />
    <RequestSendDialog ref="requestSendDialog" />
    <ErrorDialog ref="errorDialog" />
  </div>
</template>

<script setup lang="ts">
import ConnectMedtochkaDialog
  from '~/features/Home/components/FeaturesSection/ClinicFeatures/ConnectMedtochkaDialog.vue'
import RequestSendDialog from '~/features/Home/components/FeaturesSection/ClinicFeatures/RequestSendDialog.vue'
import ErrorDialog from '~/features/Home/components/FeaturesSection/ClinicFeatures/ErrorDialog.vue'
import { ConnectionRequest } from '~/features/Home/enums'
import PatientsAppClinicFeature
  from '~/features/Home/components/FeaturesSection/ClinicFeatures/PatientsAppClinicFeature.vue'
import DocumentsClinicFeature
  from '~/features/Home/components/FeaturesSection/ClinicFeatures/DocumentsClinicFeature.vue'
import TelemedClinicFeature from '~/features/Home/components/FeaturesSection/ClinicFeatures/TelemedClinicFeature.vue'
import LoyaltyClinicFeature from '~/features/Home/components/FeaturesSection/ClinicFeatures/LoyaltyClinicFeature.vue'
import MedtochkaReviews from '~/features/Home/components/FeaturesSection/ClinicFeatures/MedtochkaReviews.vue'

const connectMedtochkaDialog = ref<{ open: (request: ConnectionRequest) => void } | null>(null)
const requestSendDialog = ref<{ open: () => void } | null>(null)
const errorDialog = ref<{ open: () => void } | null>(null)

function handleConnectMedtochkaButtonClick() {
  connectMedtochkaDialog.value?.open(ConnectionRequest.Medtochka)
}

function handleConnectTelemedButtonClick() {
  connectMedtochkaDialog.value?.open(ConnectionRequest.Telemed)
}

function handleClickSend() {
  requestSendDialog.value?.open()
}

function handleError() {
  errorDialog.value?.open()
}
</script>

<style lang="scss">
@use '@/assets/vuetify/settings';
@use 'sass:map';

.clinic-features {
  margin-bottom: 88px;

  @media #{map.get(settings.$display-breakpoints, 'md-and-down')} {
    margin-bottom: 32px;
  }

  &__next-section {
    @media #{map.get(settings.$display-breakpoints, 'md-and-down')} {
      margin-top: 56px;
      padding-top: 0;
    }

    padding-top: 120px;
  }
}
</style>
